<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>ユーザ詳細</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-card outlined>
              <v-card-text>
                <v-sheet align="center">
                  <v-avatar
                    class="profile"
                    color="grey"
                    size="164"
                    tile
                  >
                    <v-img :src="user.image_url | load_image_url "></v-img>
                  </v-avatar>
                </v-sheet>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="8">
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  No
                </div>
                <h4>{{ user.no }}&nbsp;</h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="user.invisible"
                  label="非表示にする"
                  disabled
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  氏名
                </div>
                <h4>{{ user.name }}&nbsp;</h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="6">
                <div class="overline">
                  フリガナ
                </div>
                <h4>{{ user.name_furigana }}&nbsp;</h4>
                <v-divider />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  ログインID
                </div>
                <h4>{{ user.login_id }}&nbsp;</h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="6">
                <div class="overline">
                  メールアドレス
                </div>
                <h4>{{ user.email }}&nbsp;</h4>
                <v-divider />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  ロール
                </div>
                <h4>{{ user.role | user_role }}&nbsp;</h4>
                <v-divider />
              </v-col>
              <v-col
                v-if="user.role === 'driver_user'"
                cols="12"
                md="6"
              >
                <div class="overline">
                  ドライバー並び順
                </div>
                <h4>{{ user.sort_priority }}&nbsp;</h4>
                <v-divider />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="overline">
                  ドライバースケジュールを使用する
                </div>
                <h4>{{ user.use_schedule_app }}&nbsp;</h4>
                <v-divider />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="overline">
                  受注追加変更を許可
                </div>
                <h4>{{ user.app_order_edit }}&nbsp;</h4>
                <v-divider />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="overline">
                  他ドライバーのスケジュール参照を許可
                </div>
                <h4>{{ user.app_schedule_reference }}&nbsp;</h4>
                <v-divider />
              </v-col>
            </v-row>

          </v-col>
        </v-row>


        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              携帯番号
            </div>
            <h4>{{ user.mobile_number }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              電話番号
            </div>
            <h4>{{ user.phone_number }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              所属
            </div>
            <h4>{{ user.affiliation }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              役職
            </div>
            <h4>{{ user.post }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              最終ログイン日時
            </div>
            <h4>{{ user.last_login_at | unix_datetime_format }}&nbsp;</h4>
            <v-divider />
          </v-col>

          <v-col cols="12" md="6">
            <div class="overline">
              招待メール/SMS送信日時
            </div>
            <h4>{{ user.send_invitation_at | unix_datetime_format }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              作成日時
            </div>
            <h4>{{ user.created_at | unix_datetime_format }}&nbsp;</h4>
            <v-divider />
          </v-col>

          <v-col cols="12" md="6">
            <div class="overline">
              更新日時
            </div>
            <h4>{{ user.updated_at | unix_datetime_format }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="userId !== user.id"
          color="error"
          @click="deleteButtonClickEvent"
        >
          削除
        </v-btn>
        <v-spacer />
        <v-btn
          @click="cancelButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          v-if="user.email"
          @click="mailButtonClickEvent"
        >
          メール送信
        </v-btn>
        <v-btn
          v-if="user.mobile_number"
          @click="smsButtonClickEvent"
        >
          SMS送信
        </v-btn>
        <v-btn
          color="primary"
          @click="editButtonClickEvent"
        >
          編集
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>

import Confirm from '../../../../components/Confirm'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'DriverMasterUserShow',
  components: {
    Confirm
  },
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: 'ユーザ一覧', disabled: false, to: '/driver/masters/users', exact: true },
        { text: 'ユーザ詳細', disabled: true, to: '' },
      ],
      user: {}
    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'userId',
    ]),
  },
  created() {
    this.fetchUser({ id: this.$route.params.id }).then((content) => {
      this.user = content
    })
  },
  methods: {
    ...mapActions('DriverMasterUser', {
      fetchUser: 'show',
      deleteUser: 'destroy',
      sendMail: 'sendInvitationMail',
      sendSms: 'sendInvitationSms'
    }),
    editButtonClickEvent () {
      this.$router.push({name: 'DriverMasterUserEdit', params: { id: String(this.user.id) }})
    },
    deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteUser({id: this.user.id }).then(() =>{
            this.$router.push({name: 'DriverMasterUsers'})
          })
        }
      })
    },
    mailButtonClickEvent () {
      let modalOption = { title: 'メール送信', message: 'メールを送信します。よろしいですか？', options: { titleColor: 'blue' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
         this.sendMail({id: this.user.id})
        }
      })
    },
    smsButtonClickEvent () {
      let modalOption = { title: 'SMS送信', message: 'SMSを送信します。よろしいですか？', options: { titleColor: 'blue' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
         this.sendSms({id: this.user.id})
        }
      })
    },
    cancelButtonClickEvent () {
      this.$router.push( { name: 'DriverMasterUsers' } )
    },
  }
}
</script>

<style scoped>

</style>
